<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'drivers/leaves/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="searchDriver"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('FULL_NAME'),
        })
      "
    />

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FULL_NAME')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('FULL_NAME')">
            {{ scope.row.driver.first_name + ' ' + scope.row.driver.last_name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('LEAVE')"
        width="140"
      >
        <template slot-scope="scope">
          <div :data-title="$t('LEAVE')">
            {{ scope.row.is_hourly ? $t('LEAVE_HOURLY') : $t('LEAVE_DAY') }} -
            {{
              $i18n.locale == 'fa'
                ? scope.row.type.fa_title
                : scope.row.type.en_title
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('TIME')"
        width="180"
      >
        <template slot-scope="scope">
          <div :data-title="$t('TIME')">
            <span
              v-if="scope.row.is_hourly"
              class="flex items-center text-sm gap-2 flex-row flex-wrap"
            >
              <div class="flex items-center gap-1">
                <span>{{ scope.row.start | toPersianDate('dddd') }}</span>
                <span>{{
                  new Date(scope.row.start).toLocaleDateString('fa-IR')
                }}</span>
                <span>{{
                  new Date(scope.row.start).toLocaleTimeString('fa-IR')
                }}</span>
                <span class="text-gray-500">تا</span>
                <span>{{
                  new Date(scope.row.stop).toLocaleTimeString('fa-IR')
                }}</span>
              </div>
            </span>
            <span
              v-else
              class="flex items-center text-sm gap-2 flex-row flex-wrap"
            >
              <div class="flex items-center gap-1">
                <span>{{ scope.row.start | toPersianDate('dddd') }}</span>
                <span>{{
                  new Date(scope.row.start).toLocaleDateString('fa-IR')
                }}</span>
              </div>
              <span class="text-gray-500">تا</span>
              <div class="flex items-center gap-1">
                <span>{{ scope.row.stop | toPersianDate('dddd') }}</span>
                <span>{{
                  new Date(scope.row.stop).toLocaleDateString('fa-IR')
                }}</span>
              </div>
            </span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :description="scope.row.description"
              :router="{
                name: 'EDIT_DRIVER_LEAVE',
                id: scope.row.id,
              }"
              @remove="remove($event)"
              :title="$t('LEAVE_DRIVER')"
              @open="open($event)"
              @view="view($event, 'VIEW_DRIVER_LEAVE')"
              :view="true"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { driverLeaveList, removeDriverLeave } from '@/api/drivers'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import { open } from '@/mixins/openDesc'
import { view } from '@/mixins/viewPage'

export default {
  mixins: [open, view],
  data() {
    return {
      tableData: {
        results: [],
      },
      search: '',
      loading: true,
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
    }
  },

  methods: {
    searchDriver(val) {
      this.search = val
      this.$route.query.p && this.$router.replace({ p: null })
      this.tableData = []
      this.loading = true
      driverLeaveList.api(val).then((res) => {
        if (res) {
          this.tableData = res
          this.loading = false
        }
      })
    },
    remove(id) {
      removeDriverLeave.api(id).then((res) => {
        if (res) {
          this.$notify({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('VEHICLE_SERVICE'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.tableData.results = this.tableData.results.filter(
            (table) => table.id !== id
          )
        }
      })
    },
  },
  mounted() {
    driverLeaveList.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    tableSearch,
    tableFeatures,
  },
}
</script>
